import { connect } from 'react-redux';

import type { VipState } from '../../reducers';
import ShareLinks from './index';

const mapState = ({ shareLinks }: VipState) => ({ shareLinks });

export default connect(mapState)(ShareLinks);
